/*  MUI  */
import { Box, Typography } from '@mui/material';

/* Hooks */
import { useUserTheme } from 'hooks/dataAccess/User/userTheme';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

export const EmptyStateKpiPanel = ({ subtitle }) => {
    const { t } = useTranslation();
    const userTheme = useUserTheme();

    return (
        <Box
            data-testid="emptyStateKpiPanel"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
        >
            <Box width="120px" m="32px">
                <img
                    src={`/images/${userTheme}/emptyState/EmptyStateIcon.svg`}
                    alt={t('altText.emptyStateIcon')}
                    style={{ width: '120px' }}
                />
            </Box>
            <Typography color="text.secondary">{subtitle}</Typography>
        </Box>
    );
};
